import React from "react";

export default function InputField({
  type = "text",
  value,
  onChange,
  disabled = false,
  placeholder = "",
  onKeyDown,
  className = "",
  ...rest
}) {
  const baseClass =
    "w-full rounded-sm border border-[#d2d0ce] bg-white px-3 py-2 text-sm text-[#201f1e] outline-none placeholder:text-[#8a8886] focus:border-[#0f6cbd] focus:ring-2 focus:ring-[#0f6cbd]/20 disabled:cursor-not-allowed disabled:bg-[#f3f2f1] disabled:text-[#605e5c] disabled:opacity-100";

  if (type === "textarea") {
    return (
      <textarea
        value={value}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        className={`${baseClass} min-h-[88px] resize-y leading-6 ${className}`}
        {...rest}
      />
    );
  }

  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      onKeyDown={onKeyDown}
      className={`${baseClass} h-10 ${className}`}
      {...rest}
    />
  );
}